import { useEffect, useState } from "react";
import userManager from "../utils/userManager";
import { jwtDecode } from "jwt-decode";

type RefreshTokenTimeout = {
  expiry: number;
  handler: number | null;
};

export const handleSSOLogout = () => {
  try {
    clearAuthStorage();
    userManager.signoutRedirect().catch((ex) => {
      console.error(ex);
    });
  } catch (ex) {
    console.error(ex);
  }
};

const tokenRefreshError = () => {
  console.error(
    "Error occurred when trying to refresh session token. Please login again."
  );
  handleSSOLogout();
};

const refreshSSOUserToken = async () => {
  try {
    console.log("refreshing SSO token");
    const user = await userManager.signinSilent();
    console.log(user, "refreshedUser");
    const decodedToken: any = jwtDecode(user?.access_token);
    localStorage.setItem("expiry_time", decodedToken?.exp?.toString());
    localStorage.setItem("accessToken", user?.access_token);
    const actualToken =
      decodedToken[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
      ];

    localStorage.setItem("roles", actualToken);
    localStorage.setItem("location", JSON.stringify(decodedToken?.location));
  } catch (ex) {
    console.error(ex, "token refresh error");
    tokenRefreshError();
  }
};

// const getRefreshHandlerDelay = (tokenExpiry: number) =>
//   new Date(tokenExpiry * 1000).getTime() - Date.now();

//work around method for refresh token not working issue: SMR-341
const getRefreshHandlerDelay = (tokenExpiry: number) => {
  const tokenExpiryWithBuffer = tokenExpiry + 46 * 60;
  return new Date(tokenExpiryWithBuffer * 1000).getTime() - Date.now();
};

export const clearAuthStorage = () => {
  window.localStorage.clear();
};

export const useTokenRefreshTracker = () => {
  const [refreshTokenTimeout, setRefreshTokenTimeout] =
    useState<RefreshTokenTimeout>({
      expiry: 0,
      handler: null
    });

  const authenticated: boolean =
    localStorage.getItem("accessToken") !== null ? true : false;
  const expiryTime = localStorage.getItem("expiry_time");
  const tokenExpiry = expiryTime ? parseInt(expiryTime) : 0;
  useEffect(() => {
    if (
      authenticated &&
      tokenExpiry &&
      refreshTokenTimeout.expiry !== tokenExpiry
    ) {
      if (refreshTokenTimeout.handler) {
        clearTimeout(refreshTokenTimeout.handler);
      }
      const delay = getRefreshHandlerDelay(tokenExpiry);
      const timeoutId: any = setTimeout(() => {
        refreshSSOUserToken();
      }, delay * 0.33);
      setRefreshTokenTimeout({ expiry: tokenExpiry, handler: timeoutId });
    } else if (!authenticated) {
      if (refreshTokenTimeout.handler) {
        console.log("clearing timeout handler as unauthenticated");
        clearTimeout(refreshTokenTimeout.handler);
      }
    }
  }, [authenticated, tokenExpiry, refreshTokenTimeout]);
};

export const initAuthentication = (payload: any) => {
  console.log("INIT_AUTHENTICATION", payload);
};

export const isAccessTokenExpired = (expiry: any) =>
  new Date(expiry * 1000) < new Date();

export const isRefreshTokenExpired = (expiry: any) =>
  new Date(expiry * 1000 + 60000) < new Date();
